const store = require('@root/store');
const { getObjectValue } = require('@root/helpers');
const _ = require('lodash');

module.exports = (to, from, next) => {
	if (store.getters.searchQuery) {

		let shouldClearSearch = _.intersectionBy(from.matched, to.matched, 'path').length <= 1;

		if(shouldClearSearch) {
			store.commit('SET_VALUE', {
				name:  'searchQuery',
				value: ''
			});
		}
	}

	if (store.getters.privacy && !getObjectValue('meta.in_privacy', to, false)) {
		next({ path: '/configurator' });
	} else {
		next();
	}
}